import closeOuter from './lib/CloseOuter';

const viewAccessibility = (button: HTMLElement) => {
  const menu = document.querySelector('.accessibility-menu');
  document.addEventListener('click', (e) => {
    const menuActive = menu.classList.contains('accessibility-menu--active');

    const isClickInsideElement = menu.contains(<Node>e!.target);
    const menuClick = button.contains(<Node>e!.target);

    if (menuActive && !isClickInsideElement && !menuClick) {
      menu?.classList.remove('accessibility-menu--active');
    }
  });

  const outerClick = (event: Event) => {
    const clicked = event.target as HTMLElement;
    const check = closeOuter(clicked, 'accessibility-menu');
    if (check) {
      document.removeEventListener('click', outerClick);
      menu?.classList.remove('accessibility-menu--active');
    }
  };

  button.addEventListener('click', () => {
    menu?.classList.toggle('accessibility-menu--active');

    if (menu.classList.contains('accessibility-menu--active')) {
      setTimeout(() => {
        document.addEventListener('click', outerClick);
      }, 100);
    } else {
      document.removeEventListener('click', outerClick);
    }
  });
};

export default viewAccessibility;
